/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';

import { Graphql } from '@common/graphql';
import { GET_MY_ROLES } from '../../api/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { toHeaderCase } from 'js-convert-case';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { AppNavigatorService } from '@/AppNavigator';

export interface IGetUserRolesMethods extends IPluginMethodMap {
  getUserRoles(args: any): Promise<any>;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export class GetUserRolesService implements IAgentPlugin {
  readonly methods: IGetUserRolesMethods;

  constructor() {
    this.methods = {
      getUserRoles: this.getUserRoles.bind(this),
    };
  }

  async getUserRoles(args: any) {
    const storageSrv = StorageModule.getInstance();

    let gql = Graphql.withBaseUrl(apiConfig?.gql?.url);
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();

    console.log('data in query', args);
    try {
      if (client) {
        console.log(client);
        const res = await client.query(GET_MY_ROLES, {}).toPromise();
        console.log('profileress->', res, token);
        if (res?.data?.getMyRoles) {
          return { allUserRolesList: this.formatRole(res?.data?.getMyRoles) };
        }

        throw res?.data?.errors?.[0];
      }
    } catch (err: any) {
      throw err;
    }
  }

  private formatRole(role: any[]) {
    if (Array.isArray(role)) {
      return role
        .filter((item) => item?.name?.toLowerCase() !== 'director')
        ?.map((item) => {
          let name = item?.name?.[0]?.toUpperCase();
          for (let i = 1; i < item?.name?.length; i++) {
            if (item?.name?.[i] == '_' || i === 0) {
              name += ' ' + item?.name?.[i + 1]?.toUpperCase();
              i++;
            } else name += item?.name?.[i];
          }
          return {
            ...item,
            label: name === 'Owner' ? 'Admin' : name,
          };
        });
    }
    return [];
  }
}
